<kz-field [formGroup]="kazaForm">
  <label kzLabel for="kz-textbox-postcode" i18n="@@registration-create-kaza.postalCode" [isRequired]="isRequired">Your postcode</label>
  <input kzTextBox formControlName="postalCode" id="kz-textbox-postcode" type="text"/>
  <div *ngIf="kazaForm.get('postalCode')?.errors?.required && kazaForm.get('postalCode').touched" kzError i18n="@@registration-create-kaza.missingPostalCode">You must enter a postcode</div>
  <div *ngIf="kazaForm.get('postalCode')?.errors?.postalCodeValidError && kazaForm.get('postalCode').touched"
       kzError i18n="@@registration-create-kaza.wrongPostalCode">Postcode must contain 5 numbers</div>
</kz-field>
